import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { secondary } from '../App/theme';

const StyledButton = styled(Button)`
  text-transform: none !important;
  font-size: 16px !important;
  color: ${secondary.main} !important;
  border: 1px solid ${secondary.main} !important;
  box-sizing: border-box !important;
  border-radius: 30px !important;

  &:hover {
    color: #FFF !important;
    background-color: ${secondary.main} !important;
  }
`;

export default function CustomButton(params) {
  return (
    <StyledButton
      {...params}
      onClick={params && params.onClick ? params.onClick : null}
      disableRipple={true}
      variant="outlined"
      color="primary">
      {params && params.title ? params.title : 'Submit'}
    </StyledButton>
  )
}

